import React, { useState, useEffect, useRef } from 'react';
import koop from '../../assets/koop-public-logo.png';

export default function NavBar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const toggleButtonRef = useRef(null); // 👈 Add ref for toggle button

    // Close menu when clicking outside
    useEffect(() => {
        if (!isMenuOpen) return;

        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                toggleButtonRef.current &&
                !toggleButtonRef.current.contains(event.target)
            ) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

    // Prevent body scroll when menu is open (for mobile)
    useEffect(() => {
        if (isMenuOpen) {
            // document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMenuOpen]);

    const handleMenuToggle = () => {
        setIsMenuOpen((prev) => !prev);
    };

    return (
        <div className={`public-nav${isScrolled ? ' scrolled' : ''}`}>
            <div className="container">
                <a href="/" tabIndex={0}>
                    <img src={koop} alt="Koop Logo" />
                </a>

                <button
                    ref={toggleButtonRef}
                    className="menu-toggle"
                    aria-label="Toggle menu"
                    aria-expanded={isMenuOpen}
                    aria-controls="public-nav-inner"
                    onClick={handleMenuToggle}
                >
                    ☰
                </button>

                <div
                    id="public-nav-inner"
                    ref={menuRef}
                    className={`public-nav-inner${isMenuOpen ? ' open' : ''}`}
                    role="navigation"
                    aria-hidden={!isMenuOpen}
                >
                    <a href="/#activities" tabIndex={isMenuOpen ? 0 : -1}>Activities</a>
                    <a href="/#products" tabIndex={isMenuOpen ? 0 : -1}>Products</a>
                    <a href="/#faqs" tabIndex={isMenuOpen ? 0 : -1}>FAQs</a>
                    <a href="/#contact-us" tabIndex={isMenuOpen ? 0 : -1}>Contact Us</a>
                    <a href="/members" tabIndex={isMenuOpen ? 0 : -1} className="member-btn">
                        Member Login
                    </a>
                </div>

                <a href="/members" className="member-btn">
                    Member Login
                </a>
            </div>
        </div>
    );
}
